import { useEffect } from 'react'
import { useBucket } from '@mc/experiments-react'
import { paths } from '@mc/paths'
import { useStaticData } from '@mc/static-data-react'
import { trackExperimentViewed } from '@mc/track-event'
import { useGiftEnabled } from '../../../lib/helpers/useGiftEnabled'
import {
  PROMO_STICKY_FOOTER_GIFT_CTA_FLAG_NAME,
  STICKY_FOOTER_GIFT_CTA_HREF,
} from '../constants'

// Mirrors trackPen7694BackendEV in apps/next — both gates have to stay in step.
export const useExperiment = () => {
  const { giftEnabled } = useGiftEnabled()
  const { isLoggedIn, pathname } = useStaticData<{
    isLoggedIn?: boolean
    pathname?: string
  }>()
  const bucket = useBucket(PROMO_STICKY_FOOTER_GIFT_CTA_FLAG_NAME)

  const isEligible = giftEnabled && !isLoggedIn && pathname !== paths.promotion

  useEffect(() => {
    if (!isEligible) return

    trackExperimentViewed(PROMO_STICKY_FOOTER_GIFT_CTA_FLAG_NAME)
  }, [isEligible])

  return {
    giftHref:
      isEligible && bucket === 'variant_1'
        ? STICKY_FOOTER_GIFT_CTA_HREF
        : undefined,
  }
}
